import React from 'react';
import { ButtonIcon } from './buttonIcon';
import { Loading } from 'components/loading';
import styles from './style.module.scss';

export const Button = ({
  theme,
  size,
  type,
  label,
  loading,
  greyed,
  disabled,
  handleClick,
  stylesClass,
  ref,
  icon,
}) => {
  let displayIcon = '';

  if (icon === 'download') {
    displayIcon = <ButtonIcon icon="download" />;
  }
  if (icon === 'add') {
    displayIcon = <ButtonIcon icon="add" />;
  }

  if (loading) {
    return (
      <button
        className={`${styles.btn}
          ${styles[theme]}
          ${styles[size]}
          ${styles[stylesClass]}`}
        type={type}
        onClick={handleClick}
        disabled={disabled}
        ref={ref}
      >
        <span className={styles['btn-loading-icon']}>
          <Loading />
        </span>
      </button>
    );
  } else if (greyed) {
    return (
      <button
        className={
          `${styles.btn}
          ${styles[theme]}
          ${styles[size]}
          ${styles[stylesClass]}` +
          ' ' +
          (greyed ? styles['dark-transparent'] : '')
        }
        type={type}
        disabled={disabled}
        ref={ref}
      >
        <span>{label}</span>
        {displayIcon}
      </button>
    );
  }
  return (
    <button
      className={`${styles.btn}
        ${styles[theme]}
        ${styles[size]}
        ${styles[stylesClass]}`}
      type={type}
      onClick={handleClick}
      disabled={disabled}
      ref={ref}
    >
      <span>{label}</span>
      {displayIcon}
    </button>
  );
};
